export default {
  init() {
    // JavaScript to be fired on the home page
    const contactUsBlockForm = $('.contact-us-block form');
    if (contactUsBlockForm.length) {
      const submitBtn = contactUsBlockForm.find('.wpcf7-submit');

      $(document).on('wpcf7submit', function() {
        submitBtn.removeClass('disabled');
      });

      submitBtn.click(function() {
        submitBtn.addClass('disabled');
      });
    }
  },
  finalize() {},
};



// WEBPACK FOOTER //
// ./scripts/routes/acf-blocks/contactUs.js